const ModuleName = "md_button";

const ModuleDefaults = {
  whenClick: (e) => {
    console.log("被點一下");
  },
};

class Module {
  constructor(ele, options) {
    this.ele = ele;
    this.$ele = $(ele);
    this.option = options;
    this.$clickable = this.$ele.find(".md_button_clickable");
  }

  init() {
    this.clickBtnEvent();
  }

  // click事件綁模組
  clickBtnEvent() {
    let self = this;
    self.$clickable.on("click", (e) => {
      e.preventDefault();
      self.clickBtn(e);
    });
  }

  // whenclick 的 function
  clickBtn(e) {
    let self = this;
    if (self.option.whenClick) {
      self.option.whenClick(e);
    }
  }
}

$.fn[ModuleName] = function (options) {
  return this.each(function () {
    var $this = $(this);
    var module = $this.data(ModuleName);
    var opts = null;
    if (module) {
      if (typeof options === "string") {
        module[options]();
      } else {
        throw "unsupported options!";
      }
    } else {
      opts = $.extend({}, ModuleDefaults, typeof options === "object" && options);
      module = new Module(this, opts);
      $this.data(ModuleName, module);
      module.init();
    }
  });
};
